<template>
    <div :class="{ 'tw-flex tw-flex-col tw-h-full': isFullHeight }">
        <template v-if="$slots.headline || $slots.headlineSupport">
            <div class="md:tw-flex tw-items-center tw-mb-4 tw-pb-4">
                <template v-if="$slots.headline">
                    <h5 class="md:tw-flex-1 tw-text-lg tw-font-semibold tw-text-gray-700 tw-m-0">
                        <slot name="headline"></slot>
                    </h5>
                </template>
                <template v-if="$slots.headlineSupport">
                    <div class="md:tw-flex-grow-0 text-sm">
                        <slot name="headlineSupport"></slot>
                    </div>
                </template>
            </div>
        </template>
        <div class="tw-bg-white" :class="{ 'tw-flex-1 ': isFullHeight }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isFullHeight: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
